import { useMemo } from 'react';

import { isAIDPWorkflowEnabled } from '@/modules/aiDP/aidp.utils';
import { EntityType } from '@/modules/entities/types/EntityType';

/**
 * Returns whether AI DP suggestions are enabled for the given entity type/kind.
 * Checks the relevant feature flag based on the entity type/kind.
 *
 * @param entityTypeOrKind
 */
export function useAIDPSuggestionsEnabled(
  entityTypeOrKind: EntityType | undefined | null | ''
) {
  return useMemo(
    () => isAIDPWorkflowEnabled(entityTypeOrKind),
    [entityTypeOrKind]
  );
}
